module.exports = __webpack_public_path__ + "static/media/download-app.fce5d257.svg";